import React, { useState } from "react";
import { useNotify } from "react-admin";
import {
  Button,
  CircularProgress,
  Grid,
  InputAdornment,
  TextField,
} from "@mui/material";
import PropTypes from "prop-types";
import {
  payBalanceSalvageBookingsLead,
  redirectToSB,
} from "../../../../../Utils/SalvageBookingsUtils";

const PartialNotPaid = ({ sb }) => {
  const notify = useNotify();
  const [loading, setLoading] = useState(false);
  const [amount, setAmount] = useState("");
  const [validationError, setValidationError] = useState(false);

  const handleChange = (values) => {
    setValidationError(false);
    setAmount(values.currentTarget.value);
  };

  const handleButtonClick = async function () {
    if (amount === "") {
      setValidationError(true);
      notify("Amount must be entered", { type: "error" });
      return;
    }
    if (amount < 1) {
      setValidationError(true);
      notify("Amount must be at least $1", { type: "error" });
      return;
    }
    if (amount > sb.payments.outstandingBalance - 1) {
      setValidationError(true);
      notify(
        "Amount must be less than " +
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
          }).format(sb.payments.outstandingBalance - 1),
        { type: "error" }
      );
      return;
    }

    if (!loading) {
      setLoading(true);
    }

    // Post new partial payment to salvage bookings
    const responseStatus = await payBalanceSalvageBookingsLead(
      sb.quote_request_id,
      amount,
      "partial",
      ""
    );

    if (responseStatus) {
      redirectToSB(sb.quote_request_id);
      setLoading(false);
    } else {
      setLoading(false);
      notify("Something went wrong, please try again", { type: "warning" });
    }
  };

  if (sb.payments.balance != null) {
    return (
      <Grid item xs={12}>
        Balance already paid
      </Grid>
    );
  }

  return (
    <React.Fragment>
      <Grid item xs={12}>
        <Grid item xs={6}>
          <TextField
            id="partial-payment-amount"
            label="Partial Amount"
            variant="outlined"
            type="number"
            fullWidth
            onChange={handleChange}
            value={amount}
            error={validationError}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">$</InputAdornment>
              ),
            }}
            sx={{
              "& .MuiInputBase-root": {
                marginBottom: 0,
                height: "40px",
                minHeight: "40px",
              },
            }}
          />
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Grid item xs={6}>
          <Button
            variant="contained"
            color="primary"
            label="Pay Partial"
            fullWidth
            disabled={loading}
            onClick={handleButtonClick}
            sx={{
              border: "2px solid #FFF !important",
              backgroundColor: "#ED9C23",
              color: "#FFF",
              height: "40px",
              fontWeight: "700",
              "&:hover": {
                backgroundColor: "#ED9C23",
              },
            }}
          >
            Pay Partial
          </Button>
          {loading && (
            <CircularProgress
              size={24}
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                marginTop: "-12px",
                marginLeft: "-12px",
              }}
            />
          )}
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

PartialNotPaid.propTypes = {
  sb: PropTypes.object,
};

export default PartialNotPaid;
